if (!customElements.get('cart-upsell-carousel')) {
  customElements.define('cart-upsell-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-upsell-track]');
      this.prev = this.querySelector('[data-upsell-prev]');
      this.next = this.querySelector('[data-upsell-next]');
      if (!this.track) return;

      this.listeners = new AbortController();
      const { signal } = this.listeners;
      this.prev?.addEventListener('click', () => this.step(-1), { signal });
      this.next?.addEventListener('click', () => this.step(1), { signal });
      this.track.addEventListener('scroll', () => this.update(), { passive: true, signal });

      // The drawer is hidden on page load, so widths are 0 until it opens.
      this.resizeObserver = new ResizeObserver(() => this.update());
      this.resizeObserver.observe(this.track);
      this.update();
    }

    disconnectedCallback() {
      this.listeners?.abort();
      this.resizeObserver?.disconnect();
    }

    step(direction) {
      const card = this.track.firstElementChild;
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.track.scrollBy({ left: direction * (card.offsetWidth + gap), behavior: 'smooth' });
    }

    update() {
      const max = this.track.scrollWidth - this.track.clientWidth - 1;
      if (this.prev) this.prev.disabled = this.track.scrollLeft <= 0;
      if (this.next) this.next.disabled = this.track.scrollLeft >= max;
    }
  });

  // After an add/remove the theme only swaps the line items, upsells and price (section
  // api-cart-items), not the drawer's pinned blocks. Re-render the drawer section and swap
  // each carousel so products now in the cart drop out and removed ones come back.
  let refresh;
  document.addEventListener('theme:cart:change', () => {
    const section = document.querySelector('cart-upsell-carousel')?.closest('.shopify-section');
    if (!section) return;

    refresh?.abort();
    refresh = new AbortController();
    const sectionId = section.id.replace('shopify-section-', '');

    fetch(`${window.theme.routes.root}?section_id=${encodeURIComponent(sectionId)}`, { signal: refresh.signal })
      .then((response) => (response.ok ? response.text() : Promise.reject(new Error(response.statusText))))
      .then((html) => {
        const fresh = new DOMParser().parseFromString(html, 'text/html');
        document.querySelectorAll('cart-upsell-carousel').forEach((carousel) => {
          const replacement = fresh.getElementById(carousel.id);
          if (!replacement) return;
          const scrollLeft = carousel.track?.scrollLeft || 0;
          carousel.replaceWith(replacement);
          if (replacement.track) replacement.track.scrollLeft = scrollLeft;
        });
      })
      .catch((error) => {
        if (error.name !== 'AbortError') console.log(error);
      });
  });
}
